import Container from './edit-company-profile-container';

export default Container;
